export function favorite(state){
    return state.favorite
}

export function progress(state){
    return state.progress
}

export function search(state){
    return state.search
}

export function selected_areas(state){
    return state.selected_areas
}

export function subscription_type(state){
    return state.subscription_type
}

export function selected_groups(state){
    return state.selected_groups
}

export function selected_tags(state){
    return state.selected_tags
}

export function loading(state){
    return state.loading
}